"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLiveVideosProperty = exports.liveVideosPropertyDefinition = void 0;
exports.liveVideosPropertyDefinition = {
    name: 'live-videos',
    type: 'asset',
    constraints: [
        {
            name: 'stencils',
            argument: ['live-video'],
        },
    ],
    multiple: true,
    view: { label: 'Live Videos' },
};
const isLiveVideosProperty = (prop) => {
    return prop.name === exports.liveVideosPropertyDefinition.name;
};
exports.isLiveVideosProperty = isLiveVideosProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGl2ZS12aWRlb3MucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9saXZlLXZpZGVvcy5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDRCQUE0QixHQUFHO0lBQzFDLElBQUksRUFBRSxhQUFhO0lBQ25CLElBQUksRUFBRSxPQUFPO0lBQ2IsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsQ0FBQyxZQUFZLENBQUM7U0FDekI7S0FDRjtJQUNELFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLGFBQWEsRUFBRTtDQUNDLENBQUE7QUFJMUIsTUFBTSxvQkFBb0IsR0FBRyxDQUFDLElBQWtCLEVBQThCLEVBQUU7SUFDckYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLG9DQUE0QixDQUFDLElBQUksQ0FBQTtBQUN4RCxDQUFDLENBQUE7QUFGWSxRQUFBLG9CQUFvQix3QkFFaEMifQ==